/**
 * Banderas para el phone-input provisional (y posibles listados).
 * TODO: [NIF-519] Revisar/retirar al migrar al phone-input de Infinity adaptado.
 */

/**
 * Convierte un código ISO 3166-1 alpha-2 en emoji de bandera (regional indicators).
 */
export function countryFlagEmoji(iso2: string | undefined | null): string {
	if (!iso2 || iso2.length !== 2) {
		return '';
	}
	const upper = iso2.toUpperCase();
	const codePoints = [...upper].map((char) => 127397 + char.charCodeAt(0));
	return String.fromCodePoint(...codePoints);
}

/**
 * URL de bandera vía [FlagsAPI](https://flagsapi.com), mismo origen que el listado de procesos.
 */
export function countryFlagImageUrl(iso2: string | undefined | null, size = 24): string {
	if (!iso2 || iso2.length !== 2) {
		return '';
	}
	return `https://flagsapi.com/${iso2.toUpperCase()}/flat/${size}.png`;
}
